__turbopack_context__.v({
  "chart-trade-marker-enter": "chartTradeMarkers-module__N7QlWW__chart-trade-marker-enter",
  "chart-trade-marker-fade": "chartTradeMarkers-module__N7QlWW__chart-trade-marker-fade",
  "marker-enter": "chartTradeMarkers-module__N7QlWW__marker-enter",
});
